import React from 'react';

import '../styles/auth.css';

import { CloseButton } from './CloseButton';

interface ModalHeaderProps {
  title: string;
  subtitle?: React.ReactNode;
  onClose: () => void;
}

export const ModalHeader: React.FC<ModalHeaderProps> = ({ title, subtitle, onClose }) => (
  <div className="auth-modal-header">
    <CloseButton onClick={onClose} />
    <h2 className="auth-modal-title">{title}</h2>
    {subtitle && <p className="auth-modal-subtitle">{subtitle}</p>}
  </div>
);
